import {
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Search as SearchIcon } from '@material-ui/icons';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import ResourceOverview from './ResourceOverView';
import messages from './messages';

const useStyles = makeStyles({
  search: {
    width: '100%',
    height: '50px',
    borderRadius: '4px',
    fontSize: '14px',
    marginTop: '16px',
    marginBottom: '16px'
  },
  checkbox: {
    margin: '16px 0',
    '& .MuiFormControlLabel-label': {
      fontSize: '13px',
      fontWeight: 600,
      color: '#000'
    }
  },
  searchButton: {
    padding: 0,

    '& .MuiSvgIcon-root': {
      fontSize: '32px',
      color: '#d4d1d1'
    }
  }
});

const AssignCardToResource = ({ resources, setSelectedResource, selectedResource }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showNoActiveCards, setShowNoActiveCards] = useState(false);

  const classes = useStyles();
  const intl = useIntl();

  const handleCheckboxChange = event => {
    setSelectedResource(null);
    setShowNoActiveCards(event.target.checked);
  };
  const handleSearch = event => {
    setSelectedResource(null);
    setSearchTerm(event.target.value);
  };

  const handleSelectResource = resourceId => {
    setSelectedResource(resourceId);
  };

  const filteredResources = resources.filter(({ name, assignedCardsAmount }) => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const isNoActiveCards = assignedCardsAmount === 0;

    return (
      name.toLowerCase().includes(lowerCaseSearchTerm) &&
      (showNoActiveCards ? isNoActiveCards : true)
    );
  });

  return (
    <div className="w-full">
      <h2 className="text-xl font-bold text-slate-800">{intl.formatMessage(messages.selectResource)}</h2>
      <div className="text-sm text-slate-500 mt-1">
        {intl.formatMessage(messages.selectResourceInfo)}
      </div>
      <TextField
        type="text"
        label={intl.formatMessage(messages.searchLabel)}
        placeholder={intl.formatMessage(messages.searchPlaceholder)}
        variant="outlined"
        value={searchTerm}
        className={classes.search}
        onChange={handleSearch}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton className={classes.searchButton}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />

      <FormControlLabel
        className={classes.checkbox}
        control={
          <Checkbox checked={showNoActiveCards} onChange={handleCheckboxChange} color="primary" />
        }
        label={intl.formatMessage(messages.checkboxLabel)}
      />
      <div className="border-y border-solid border-slate-200 bg-white p-5 h-[350px] overflow-y-auto">
        {filteredResources.length ? (
          filteredResources.map((resource, index) => (
            <ResourceOverview
              resource={resource}
              key={index}
              selectedResource={selectedResource}
              handleSelectResource={handleSelectResource}>
              {resource.name}
            </ResourceOverview>
          ))
        ) : (
          <div className="flex items-center justify-center w-full h-full text-slate-400">
            {intl.formatMessage(messages.emptyDataSourceMessage)}
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignCardToResource;
